import { useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import RHFTextField from '../../Components/RHFTextField';
import RHFSelect from '../../Components/RHFSelect';
import ChipField from '../../Components/ChipField';
import { useLazyGetBusinessOptionsQuery, useLazyGetIndustryOptionsQuery } from '../../Api/BuzIndType.api';
import { useEffect, useState } from 'react';

interface ChiptypeProps {
  businesstype?: string;
  value?: string;
  isactive?: number;
  restrictedflag?: number;
  id: number;
}
const Step1Basic = () => {
  const [businessTypes, setBusinessTypes] = useState<ChiptypeProps[]>([]);
  const [selectedBusinessTypes, setSelectedBusinessTypes] = useState<string[]>([]);
  const [industryTypes, setIndustryTypes] = useState([]);
  const { watch } = useFormContext();
  const [businessTypeFn, { data: BizData }] = useLazyGetBusinessOptionsQuery();
  const [IndustryTypeFn, { data: IndData }] = useLazyGetIndustryOptionsQuery();
  const values = watch(['businessLegalName', 'businessBrandName', 'city']);
  console.log(values, 'values');

  useEffect(() => {
    const bizInd = async () => {
      const busData = await businessTypeFn();
      const indData = await IndustryTypeFn();
      const businesslistArr = busData.data ?? [];
      const convertedList: ChiptypeProps[] = businesslistArr.map((item) => ({
        businesstype: item.businesstype ?? '',
        value: item.businesstype ?? '',
        isactive: item.isactive ?? 0,
        restrictedflag: 0,
        id: item.businesstypeid ?? 0,
      }));

      const biz: ChiptypeProps[] = [
        ...convertedList,
        {
          businesstype: 'Add Business Type',
          value: 'Add Business Type',
          isactive: 0,
          restrictedflag: 1,
          id: 0,
        },
      ];

      setBusinessTypes(biz);
      // setBusinessTypes(biz);

      const IndustryListArr = indData?.data;
    };
    bizInd();
  }, []);
  console.log(businessTypes, 'businessTypes');

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={4}>
        <RHFTextField name="businessLegalName" label="Business Legal Name" />
      </Grid>
      <Grid item xs={4}>
        <RHFTextField name="businessBrandName" label="Brand Name" />
      </Grid>
      <Grid item xs={4}>
        <RHFTextField name="communicationEmail" label="Communication Email" />
      </Grid>

      <Grid item xs={4}>
        {/* Phone Input */}
        <RHFTextField name="mobile" label="Mobile" />
      </Grid>

      <Grid item xs={4}>
        <RHFTextField name="websiteLink" label="Website Link" />
      </Grid>

      <Grid item xs={4}>
        <RHFSelect name="currency" label="Currency" value={'1'} options={[{ label: 'Rupee (₹)', value: '1' }]} disabled={true} />
      </Grid>
      <Grid item xs={4}>
        <ChipField id="businessTypes" label="Currency" value={'1'} options={businessTypes} />
      </Grid>
    </Grid>
  );
};

export default Step1Basic;
